<template lang="pug">
  section.section
    b-field(v-if="manipulated_order_items.length == 0")
      b-upload(v-model="dropFile" @input="input" drag-drop id="csv-upload" :loading="loading")
        section(class="section")
          div(class="content has-text-centered")
            p
              b-icon(pack="fas" custom-class="fa-2x fa-file-csv")
            p
              | CSVファイルをドラッグしてください
    b-message(title="エラー" type="is-danger" has-icon :active="error_message != null")
      | {{ error_message }}

    b-field(v-if="manipulated_order_items.length > 0")
      .columns
        .column
          button(@click="submit" class="button is-danger" :disable="enableSubmitButton == false" id="submit-button")
            i.fa.fa-plus.fa-fw
            | 配本登録
        .column.is-one-fifth
          .tag.is-rounded.is-light.is-medium.is-pulled-right
            | 横スクロール
            i.fas.fa-fw.fa-arrow-right
    b-field
      .scroll-table
        b-table(
          :data="manipulated_order_items"
          :loading="loading"
          narrowed
          hoverable
          striped
          paginated
          per-page="100"
          )
          template(slot-scope="props")
            b-table-column(field="i" label="No." width="40" sortable)
              b-field {{ props.row.i }}
            b-table-column(field="id" label="ID" width="50" sortable)
              b-field {{ props.row.id }}
            b-table-column(field="accepting_order_item_id" label="受注ID" width="100" sortable)
              b-field {{ props.row.accepting_order_item_id }}
            b-table-column(field="isbn" label="ISBN13" width="200")
              | {{ props.row.isbn }}
            b-table-column(field="isbn" label="書籍名" width="400")
              | {{ bookName(props.row.isbn) }}
            b-table-column(field="agency_shop_code" label="取次書店コード" width="110")
              | {{ props.row.agency_shop_code }}
            b-table-column(field="shop_name" label="書店名"  width="300")
              | {{ props.row.book_shop_name }}
            b-table-column(field="bansen" label="番線" width="50")
              | {{ props.row.bansen }}
            b-table-column(field="agency_code" label="帳合" width="100")
              | {{ agencyName(props.row.agency_code) }}
            b-table-column(field="order_route_id" label="受注経路" width="100")
              | {{ orderRouteName(props.row.order_route_id) }}
            b-table-column(field="deliver_type_id" label="出荷属性" width="150")
              deliver-type-id-input(
                :doValidate="true"
                v-model="props.row.deliver_type_id"
                input_name="出荷属性"
                :deliver_types="deliver_types"
                immediate
              )
            b-table-column(field="sales_person_id" label="営業担当" width="100")
              | {{ salesPersonName(props.row.sales_person_id) }}
            b-table-column(field="kyakutyu_memo" label="客注メモ" width="200")
              | {{ props.row.kyakutyu_memo }}
            b-table-column(field="bibo" label="備忘" width="200")
              | {{ props.row.bibo }}
            b-table-column(field="accepting_date" label="受注日" width="100")
              | {{ props.row.accepting_date | moment("YYYY/MM/DD") }}
            b-table-column(field="accepting_order_number" label="発注数" width="80")
              | {{ props.row.accepting_order_number }}
            b-table-column(field="delivered_number" label="配本済数" width="80")
              | {{ props.row.manipulated_number }}
            b-table-column(field="order_number" label="配本数" width="80")
              ValidationProvider(
                :rules="isDestroy(props.row) == false ? `required|min_value:0|max_value:${props.row.accepting_order_number - props.row.manipulated_number}` : ''"
                v-slot="{ errors }"
                name="配本数"
                ref="order_number"
                immediate
              )
                b-field(:type="{'is-danger': errors.length > 0 }"
                      :message="errors[0]")
                  b-input(
                    :data-vv-name="'order_number' + props.row.i"
                    data-vv-as="order_number"
                    type="number"
                    size="is-small"
                    v-model="props.row.order_number"
                    :disabled="isDestroy(props.row)"
                  )
            b-table-column(field="delivered_number" label="残数" width="50")
              | {{ props.row.accepting_order_number - props.row.order_number - props.row.manipulated_number }}
    b-field(v-if="manipulated_order_items.length > 0")
      button(@click="submit" class="button is-danger" :disable="enableSubmitButton == false")
        i.fa.fa-plus.fa-fw
        | 配本登録
</template>

<script>
  // import AbstractAcceptingOrderFields  from 'components/accepting_orders/abstract_accepting_order_fields'
  import Papa from 'papaparse';
  import AcceptingOrderItem from 'models/accepting_order_item'
  import ManipulatedOrderItem from 'models/manipulated_order_item'
  import CacheDispatcher from 'mixins/cache_dispatcher'
  import { ValidationProvider } from 'vee-validate'
  import DeliverTypeIdInput from 'inputs/deliver_type_id_input'

  export default {
    name: 'new-multiple-manipulated-orders',
    mixins: [CacheDispatcher],
    components: {
      ValidationProvider,
      DeliverTypeIdInput
      },
    data() {
      return {
        loading: false,
        dropFile: null,
        accepting_order_items: {},
        manipulated_order_items: [],
        error_message: null,
        error_rows: []
      }
    },
    computed: {
      books(){  return this.$store.getters['Books/records'] },
      accepting_order_routes(){ return this.$store.getters['AcceptingOrderRoutes/records'] },
      agencies(){ return this.$store.getters['Agencies/records'] },
      final_book_shop_agencies(){ return this.$store.getters['FinalBookShopAgencies/records'] },
      final_book_shops(){ return this.$store.getters['FinalBookShops/records'] },
      shop_people(){ return this.$store.getters['ShopPeople/records'] },
      deliver_types(){ return this.$store.getters['DeliverTypes/records'] },
      sales_people(){ return this.$store.getters['SalesPeople/records'] },
      enableSubmitButton(){
        return this.manipulated_order_items.length != 0
      },
    },
    methods: {
      has_errors() {
        return document.querySelector("input.is-danger") || this.error_rows.length > 0 || this.filterManipulatedOrderItems().length == 0
      },
      filterManipulatedOrderItems() {
        let filtered_manipulated_order_items = this.manipulated_order_items.reduce((result, item) =>{
          let order_number = parseInt(item.order_number)
          let min_order_number = 0
          let max_order_number = item.accepting_order_number - item.manipulated_number
          if((order_number > min_order_number && order_number <= max_order_number) && item.deliver_type_id) {
            let attr = {
              accepting_order_item_id: item.accepting_order_item_id,
              order_number: order_number,
              deliver_type_id: item.deliver_type_id,
            }
            result.push(attr)
          } else if(order_number != min_order_number) {
            this.error_rows.push(item.i)
          }
          return result
        }, [])
        return filtered_manipulated_order_items
      },
      async submit(){
        var method = 'post'
        var url = `/api/v1/multiple_manipulated_orders.json`
        var manipulated_order_items = this.filterManipulatedOrderItems()
        var params = {
          multiple_manipulated_order: {
            manipulated_order_items_attributes: manipulated_order_items
          }
        }

         if(this.has_errors()) {
            const message = this.error_rows.length > 0 ? `行${this.error_rows.join(',\n')}にエラーがあります。` : '登録情報にエラーがあります。'
            this.$toast.open({
              message: message,
              type: 'is-danger',
              position: 'is-bottom',
              duration: 3500
            })
            this.error_rows = []
            return
          }

        this.loading = true
        this.error_message = null
        try{
          const res = await this.$http({ method: method, url: url, data: params })
          const data = res.data
          this.loading = false
          window.location.href = `/users/manipulated_orders/`
        }catch (error) {
          const {
            status,
            statusText,
            data
          } = error.response;
          this.loading = false
          this.error_message = data.messages.map((msg) => { return msg.message }).join(",")
          throw error
        }
      },
      isDestroy(item){
        return item._destroy == "1"
      },
      bookName(value){
        if (!value) return ''
        let a = this.books.filter(book => book.isbn == value)
        return a.length > 0 ? a[0].name : ''
      },
      shopName(agency_code, agency_shop_code){
        if (!agency_code) return ''
        let tmp = this.final_book_shop_agencies
            .filter(final_book_shop_agency => final_book_shop_agency.agency_code == agency_code && final_book_shop_agency.agency_shop_code == agency_shop_code)
        if(tmp.length == 0)
          return ''
        let shop_code = tmp[0].shop_code
        let final_book_shops = this.final_book_shops.filter(final_book_shop => final_book_shop.shop_code == shop_code)
        return final_book_shops.length > 0 ? `${final_book_shops[0].name}` : ''
      },
      agencyName(agency_code){
        if (!agency_code) return ''
        let tmp = this.agencies
            .filter(agency => agency.code == agency_code)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      orderRouteName(id){
        if (!id) return ''
        let tmp = this.accepting_order_routes
            .filter(route => route.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      deliverTypeName(id){
        if (!id) return ''
        let tmp = this.deliver_types
            .filter(type => type.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      salesPersonName(id){
        if (!id) return ''
        let tmp = this.sales_people
            .filter(type => type.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },

      async fetchAcceptingOrderItems(data){
        let records = data.filter((record) => /^[-]?([1-9]\d*|0)(\.\d+)?$/.test(record[0]))
        let ids = records.map((record) => {  return record[0] })

        const params = {
          page: 1,
          per_page: 9999999,
          q: {
            id_in: ids,
            only_uncompleted: true
          }
        }

        this.loading = true
        try{
          const res = await this.$http.post('/api/v1/accepting_order_items/search', params)
          const data = res.data
          if(data.accepting_order_items.length == 0) {
            this.accepting_order_items = {}
            this.total = 0
            this.loading = false
            this.$toast.open({
              message: '配本登録済みか不正なデータが入力されました。',
              type: 'is-danger',
              position: 'is-bottom'
            })
            return
          }

          this.accepting_order_items = {}
          let currentTotal = data.total_results
          if (data.total_results / this.perPage > 1000) {
            currentTotal = this.perPage * 1000
          }
          this.total = currentTotal
          data.accepting_order_items.forEach((item) => {
            let a = new AcceptingOrderItem(item)
            this.accepting_order_items[a.id] = Object.assign({}, a)
          })
          this.loading = false
        }catch (error) {
          const {
            status,
            statusText
          } = error.response;
          this.accepting_order_items = {}
          this.total = 0
          this.loading = false
          this.$toast.open({
            message: 'データの取得に失敗しました。',
            type: 'is-danger',
            position: 'is-bottom'
          })
          throw error
        }
        this.manipulated_order_items = []
        this.manipulated_order_items = records.map((record) => {
          this.accepting_order_items[record[0]].accepting_order_item_id  = this.accepting_order_items[record[0]].id
          this.accepting_order_items[record[0]].id = null
          this.accepting_order_items[record[0]].accepting_order_number  = this.accepting_order_items[record[0]].order_number
          this.accepting_order_items[record[0]].order_number = null
          let m = new ManipulatedOrderItem(this.accepting_order_items[record[0]])
          m.order_number = record[19]
          m.deliver_type_id = this.deliverTypeId(record[12])
          return Object.assign({}, m)
        })

      },
      input(file){
        Papa.parse(file, {
          complete: (results) => {
            this.fetchAcceptingOrderItems(results.data)
          }
        });
      },
      deliverTypeId(deliver_type_name) {
        const deliver_type = this.deliver_types.find(type => type.name == deliver_type_name)
        return deliver_type ? deliver_type.id : null
      }
    },
    created() {
      this.dispatch_with_cache('Agencies/fetch', 'agencies', this.agencies)
      // this.$store.dispatch('FinalBookShopAgencies/fetch', [ 'final_book_shop_agencies', null, { query: 'mode=simple' }])
      // this.$store.dispatch('FinalBookShops/fetch', [ 'final_book_shops', null, { query: 'mode=simple' }])
      this.$store.dispatch('Books/fetch', 'books')
      this.dispatch_with_cache('AcceptingOrderRoutes/fetch', 'accepting_order_routes', this.accepting_order_routes)
      this.$store.dispatch('DeliverTypes/fetch', 'deliver_types')
      this.dispatch_with_cache('SalesPeople/fetch', 'sales_people', this.sales_people)
    }
  }
</script>